<div class="payment-frequency">{{paymentFrequency | translate}}</div>


